// extracted by mini-css-extract-plugin
module.exports = {"container":"Content_container__V_9lg","header":"Content_header__Rsk1d","heading":"Content_heading__rVFzg"};